<template>
  <div class="custom-tiptap-editor">
    <vs-row v-if="isEditing" class="mb-3">
      <vs-button
        @click="editor.chain().focus().toggleBold().run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('bold') ? 'filled' : 'border'"
      >
        B
      </vs-button>
      <vs-button
        @click="editor.chain().focus().toggleItalic().run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('italic') ? 'filled' : 'border'"
      >
        I
      </vs-button>
      <vs-button
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('heading', { level: 1 }) ? 'filled' : 'border'"
      >
        h1
      </vs-button>
      <vs-button
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('heading', { level: 2 }) ? 'filled' : 'border'"
      >
        h2
      </vs-button>
      <vs-button
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('heading', { level: 3 }) ? 'filled' : 'border'"
      >
        h3
      </vs-button>
      <vs-button
        @click="editor.chain().focus().toggleBulletList().run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('bulletList') ? 'filled' : 'border'"
        icon="format_list_bulleted"
      >
      </vs-button>
      <vs-button
        @click="editor.chain().focus().toggleOrderedList().run()"
        size="small"
        class="px-3 mr-1"
        :type="editor.isActive('orderedList') ? 'filled' : 'border'"
        icon="format_list_numbered"
      >
      </vs-button>
    </vs-row>
    <editor-content :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";

export default {
  components: {
    EditorContent,
  },

  props: ["isEditing", "value", "defaultText"],
  data() {
    return {
      editor: null,
    };
  },

  watch: {
    value(val) {
      if (val == null) {
        this.editor.commands.setContent(this.defaultText, false);
        return;
      }
      // HTML
      const isSame = this.editor.getHTML() === val.comment;

      // JSON
      // const isSame = this.editor.getJSON().toString() === value.toString()

      if (isSame) {
        return;
      }

      this.editor.commands.setContent(val.comment, false);
    },
  },

  mounted() {
    this.editor = new Editor({
      extensions: [StarterKit],
      editable: false,
      content: "",
      onUpdate: () => {
        // HTML
        this.$emit("onUpdate", this.editor.getHTML());
      },
    });
  },

  methods: {
    setEditable(value) {
      this.editor.setEditable(value);
    },
  },

  //   computed: {
  //     valueModel: {
  //       get() {
  //         console.log("Getting", this.value);
  //         return this.value;
  //       },
  //       set(value) {
  //         console.log("Setting", this.value);
  //         this.$emit("onUpdate", value);
  //       },
  //     },
  //   },

  beforeDestroy() {
    this.editor.destroy();
  },
};
</script>

<style lang="scss">
.custom-tiptap-editor {
  .vs-button {
    &:not(.vs-button-border) {
      border: 1px solid transparent;
    }
    transition: all 0.05s ease;
    font-size: 0.9rem;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.includeIconOnly.small {
      width: 32px !important;
      height: 32px !important;
    }

    > i.vs-icon {
      font-size: 1.5rem !important;
    }
  }

  /* Basic editor styles */
  .ProseMirror {
    > * + * {
      margin-top: 0.75em;
    }

    ul,
    ol {
      padding-inline-start: 24px;
    }
    ol {
      list-style-type: decimal !important;
    }
    ul {
      list-style-type: disc !important;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
    }

    code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
    }

    pre {
      background: #0d0d0d;
      color: #fff;
      font-family: "JetBrainsMono", monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;

      code {
        color: inherit;
        padding: 0;
        background: none;
        font-size: 0.8rem;
      }
    }

    img {
      max-width: 100%;
      height: auto;
    }

    blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0d0d0d, 0.1);
    }

    hr {
      border: none;
      border-top: 2px solid rgba(#0d0d0d, 0.1);
      margin: 2rem 0;
    }
  }
}
</style>